import classNames from "classnames"
import "./subtitle.scss"

const Subtitle = ({ children, className, ...props }) => {
  return (
    <h3
      className={classNames("landing-subtitle", { [className]: className })}
      {...props}
    >
      {children}
    </h3>
  )
}

export default Subtitle
